<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <div class="floating-buttons">
            <button :disabled="is_excel_export" class="fl-button" type="button" v-on:click="excelExport"><i class="fa fa-file-excel"></i></button>
          </div>
          <h1>Átjáró Riport</h1>

          <div class="row">
            <div class="col-xs-2">
              <comboboxV2 @input="getElements" id="element_type_id" label="Típus" name="element_type_id" v-model="element_type_id" :options="element_types"/>
            </div>
            <div v-if="elements.length > 0" class="col-xs-2">
              <select2 style="width: 300px;" @onChange="getItems" label="Eszköz" name="element_id" id="element_id" :options="elements" v-model="element_id"/>
            </div>
          </div>

          <div v-show="element_id != 0">
            <div class="row">
              <div class="col-sm-8">
                <h2>Access Levels</h2>
                <div v-if="accesslevels.length > 0">
                  <table class="list">
                  <thead>
                    <tr>
                      <th>Név</th>
                      <th>Engedélyezve</th>
                      <th>Tiltva</th>
                      <th>Aktív kártyák</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="accesslevel in accesslevels">
                      <td>{{accesslevel.access_level}}</td>
                      <td>
                        {{ accesslevel.allowed ? accesslevel.allowed : '-' }}
                        <ul v-if="Object.keys(accesslevel.allowed_schedule).length" class="small-buttons">
                          <li>
                            <a class="small-button inline with-menu" href="javascript:void(0)"><i class="fa fa-search"></i></a>
                            <div class="small-button-menu inline">
                              <div class="head">Heti szabályok</div>
                              <ul v-for="(days,index) in accesslevel.allowed_schedule">
                                <li v-for="item in days">{{index}}: {{item.start_time}}-{{item.end_time}}</li>
                              </ul>
                            </div>
                          </li>
                        </ul>
                      </td>
                      <td>
                        {{ accesslevel.denied ? accesslevel.denied : '-' }}
                        <ul v-if="Object.keys(accesslevel.denied_schedule).length" class="small-buttons">
                          <li>
                            <a class="small-button inline with-menu" href="javascript:void(0)"><i class="fa fa-search"></i></a>
                            <div class="small-button-menu inline">
                              <div class="head">Heti szabályok</div>
                              <ul v-for="(days,index) in accesslevel.denied_schedule">
                                <li v-for="item in days">{{index}}: {{item.start_time}}-{{item.end_time}}</li>
                              </ul>
                            </div>
                          </li>
                        </ul>
                      </td>
                      <td>{{accesslevel.active_cards}}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="3"><b>Egyéni jogosultságok</b></td>
                      <td><b>{{accesslevels_sumcards}}</b></td>
                    </tr>
                  </tfoot>
                </table>
                </div>
                <div v-else>
                  Nincs találat.
                </div>
              </div>
              <div class="col-sm-4">
                <h2>Heti nyitvatartás</h2>
                <div v-if="openings.length > 0">
                  <table class="list">
                  <thead>
                    <tr>
                      <th>Nap</th>
                      <th>Nyitás</th>
                      <th>Zárás</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="opening in openings">
                      <td>{{opening.day_name}}</td>
                      <td>{{opening.open}}</td>
                      <td>{{opening.close}}</td>
                    </tr>
                  </tbody>
                </table>
                </div>
                <div v-else>
                  Nincs találat.
                </div>
                <h2>Jövőbeli rendhagyó nyitvatartás</h2>
                <div v-if="opening_spec_days.length > 0">
                  <table class="list">
                  <thead>
                    <tr>
                      <th>Kezdő dátum</th>
                      <th>Vég dátum</th>
                      <th>Időponttól</th>
                      <th>Időpotig</th>
                      <th>Szabály</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="opening_spec_day in opening_spec_days">
                      <td>{{opening_spec_day.date_from}}</td>
                      <td>{{opening_spec_day.date_to}}</td>
                      <td>{{opening_spec_day.time_from}}</td>
                      <td>{{opening_spec_day.time_to}}</td>
                      <td>{{opening_spec_day.close ? "Zárva" : "Nyitva"}}</td>
                    </tr>
                  </tbody>
                </table>
                </div>
                <div v-else>
                  Nincs találat.
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                  <h2>Jövőbeli rendhagyó jogosultságú dátumok</h2>
                  <div v-if="spec_days.length > 0">
                    <table class="list">
                    <thead>
                      <tr>
                        <th>Megnevezés</th>
                        <th>Access Levels</th>
                        <th>Kezdő dátum</th>
                        <th>Vég dátum</th>
                        <th>Időponttől</th>
                        <th>Időpontig</th>
                        <th>Szabály</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="spec_day in spec_days">
                        <td>{{spec_day.name}}</td>
                        <td>
                          <ul style="padding:0;">
                            <li style="list-style-type:none;" v-for="spec_day_access_level in spec_day.access_levels">{{spec_day_access_level}}</li>
                          </ul>
                        </td>
                        <td>{{spec_day.start_date}}</td>
                        <td>{{spec_day.end_date}}</td>
                        <td>{{spec_day.start_time}}</td>
                        <td>{{spec_day.end_time}}</td>
                        <td>{{spec_day.operation}}</td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                  <div v-else>
                    Nincs találat.
                  </div>
                </div>
              </div>
            </div>

        </div>
      </div>
    </div>

    <HTMLFooter></HTMLFooter>
    <ProgressInfo :show="is_excel_export"/>
  </div>
</template>
<script>
import Vue from 'vue';

export default {
  components: {
  },

  data: function() {
    return {
      element_types: [],
      element_type_id: 0,
      elements: [],
      element_id: 0,
      accesslevels: [],
      openings: [],
      accesslevels_sumcards: 0,
      is_excel_export: false,
      spec_days: [],
      opening_spec_days: []
    }
  },

  mounted: function() {
    var _this = this;

    this.$root.checkRootUserHasSet(function() {
      _this.$root.ajax('report/init/' + _this.$root.user.apikey, {
        method: 'GET',
        success: function(response) {
          _this.element_types = response.element_types;
        }
      });
    });
  },

  methods: {
    getItems: function() {
      this.getAccessLevels();
      this.getOpenings();
    },

    getAccessLevels: function() {
      var _this = this;

      this.accesslevels = [];
      this.accesslevels_sumcards = 0;

      if (this.element_id != 0) {
        this.$root.checkRootUserHasSet(function() {
          _this.$root.ajax('report/accesslevels/' + _this.element_id + '/' + _this.$root.user.apikey, {
            method: 'GET',
            success: function(response) {
              _this.accesslevels = response.elements;
              _this.accesslevels_sumcards = response.unique_cards;
              _this.spec_days = response.spec_days;
            }
          });
        });
      }
    },

    getOpenings: function() {
      var _this = this;

      this.openings = [];

      if (this.element_id != 0) {
        this.$root.checkRootUserHasSet(function() {
          _this.$root.ajax('report/openings/' + _this.element_id + '/' + _this.$root.user.apikey, {
            method: 'GET',
            success: function(response) {
              _this.openings = response.elements;
              _this.opening_spec_days = response.opening_spec_days;
            }
          });
        });
      }
    },

    getElements: function() {
      var _this = this;

      this.element_id = 0;
      this.elements = [];
      this.items = [];
      this.items_ = [];

      if (this.element_type_id != 0) {
        this.$root.checkRootUserHasSet(function() {
          _this.$root.ajax('report/elements/' + _this.element_type_id + '/' + _this.$root.user.apikey, {
            method: 'GET',
            success: function(response) {
              _this.elements = response.elements;
            }
          });
        });
      }
    },


    excelExport: function() {
      var _this = this;
      this.is_excel_export = true;

      if (this.element_id != 0) {
        this.$root.checkRootUserHasSet(function() {
          _this.$root.ajax('report/export/' + _this.element_id + '/' + _this.$root.user.apikey, {
            method: 'GET',
            success: function(response) {
              _this.is_excel_export = false;

              if (response.filename != undefined) {
                window.open('assets/excel_export/' + response.filename);
              } else {
                swal('Figyelem', 'Az exportálás során hiba történt: ' + response.error, 'error');
              }
            }
          });
        });
      }
    },
  }
}
</script>


// WEBPACK FOOTER //
// report.vue?70f1b426